import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between gap-x-2 mb-4" }
const _hoisted_2 = { class: "text-base font-semibold" }
const _hoisted_3 = { class: "flex items-center justify-between gap-x-2" }
const _hoisted_4 = {
  class: "w-400px select bg-white rounded-md font-montserrat flex flex-col gap-y-3 divide-y divide-gray-lp-400",
  style: { maxHeight: '70vh' }
}
const _hoisted_5 = { class: "w-full px-4 pt-3" }
const _hoisted_6 = { class: "w-full px-4 pt-3" }
const _hoisted_7 = { class: "flex gap-x-2 items-center py-2 px-4 pt-3" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "flex items-center justify-between gap-2 w-full" }
const _hoisted_11 = { class: "font-bold white-space-nowrap" }
const _hoisted_12 = { class: "flex items-center gap-x-2" }
const _hoisted_13 = { class: "flex items-center gap-x-2" }
const _hoisted_14 = { class: "text-gray-lp-800 font-semibold" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "w-1.5 h-1.5 rounded-full bg-gray-lp-400" }, null, -1)
const _hoisted_16 = { class: "text-black-lp-300 font-normal" }
const _hoisted_17 = { class: "m-0 mb-3 font-montserrat bg-gray-lp-1000 px-4 rounded-b-lg text-sm" }
const _hoisted_18 = { class: "flex items-center gap-1 w-full" }
const _hoisted_19 = { class: "flex items-center justify-between gap-x-2" }
const _hoisted_20 = { class: "text-black-lp-100 font-semibold" }
const _hoisted_21 = { class: "text-black-lp-300 font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_component_Card, {
    "data-testid": "client-rate-history-card",
    class: "border border-gray-lp-400 bg-white rounded-2xl shadow p-4 flex flex-col",
    rounded: "2xl",
    ref: "cardRef"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("clientManagement.clientRateHistory.history")), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DateRangePicker, {
            modelValue: _ctx.filter.date,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.date = $event)),
            class: "w-full",
            "max-range": 31,
            "max-date": new Date(),
            onApply: _ctx.onApplyFilter
          }, {
            trigger: _withCtx(({ onClick }) => [
              _createVNode("button", { onClick: onClick }, [
                _createVNode(_component_Icons, {
                  name: "calendar",
                  class: "h-5"
                })
              ], 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "max-date", "onApply"]),
          _createVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePanel && _ctx.togglePanel(...args)))
          }, [
            _createVNode(_component_Icons, {
              name: "filter",
              class: "h-4"
            })
          ]),
          _createVNode(_component_OverlayPanel, {
            ref: "priceHistoryFilterPanel",
            id: "client-rate-history-filter"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('clientManagement.clientRateHistory.status')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomDropdown, {
                        modelValue: _ctx.filter.status,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.status = $event)),
                        selectedItem: _ctx.filter.status,
                        options: _ctx.statusOptions,
                        placeholder: _ctx.$t('clientManagement.clientRateHistory.all'),
                        class: "w-full my-2"
                      }, null, 8, ["modelValue", "selectedItem", "options", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('clientManagement.clientRateHistory.type')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomDropdown, {
                        modelValue: _ctx.filter.type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.type = $event)),
                        selectedItem: _ctx.filter.type,
                        options: _ctx.typeOptions,
                        placeholder: _ctx.$t('clientManagement.clientRateHistory.all'),
                        class: "w-full my-2"
                      }, null, 8, ["modelValue", "selectedItem", "options", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_LpButton, {
                      color: "white",
                      textColor: "red-lp-100",
                      title: _ctx.$t('clientManagement.clientRateHistory.reset'),
                      flat: "",
                      isWidthFull: "",
                      onClick: _ctx.onResetFilter
                    }, null, 8, ["title", "onClick"])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_LpButton, {
                      color: "red-lp-100",
                      textColor: "white",
                      title: _ctx.$t('clientManagement.clientRateHistory.apply'),
                      isWidthFull: "",
                      onClick: _ctx.onApplyFilter,
                      disabled: _ctx.disabledFilter
                    }, null, 8, ["title", "onClick", "disabled"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      (!_ctx.listData.data.length && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_EmptyList, {
            key: 0,
            icon: "error-token-ngen",
            customHeaderMessage: _ctx.$t('clientManagement.clientRateHistory.noHistory'),
            customMessage: _ctx.$t('clientManagement.clientRateHistory.noHistory')
          }, null, 8, ["customHeaderMessage", "customMessage"]))
        : (_ctx.listData.data?.length && !_ctx.loading)
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              "data-testid": "client-rate-history-list",
              class: "overflow-y-auto",
              style: { maxHeight: _ctx.maxScrollHeight + 'px' }
            }, [
              _createVNode(_component_Accordion, {
                id: "client-rate-history-accordion",
                multiple: "",
                activeIndex: _ctx.activeIndexMenu,
                "onUpdate:activeIndex": _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeIndexMenu = $event)),
                class: "flex flex-col"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData.data, (item, index) => {
                    return (_openBlock(), _createBlock(_component_AccordionTab, {
                      key: item.clientCustomRateId
                    }, {
                      header: _withCtx(() => [
                        _createVNode("div", {
                          class: ["flex flex-col gap-y-1 w-full py-2 font-montserrat text-sm", index && 'border-t border-gray-lp-400']
                        }, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode("span", _hoisted_11, _toDisplayString(item.labelRequestType), 1),
                            _createVNode("div", _hoisted_12, [
                              _createVNode(_component_ChipsV2, {
                                label: _ctx.getStatus(item.clientStatusCustomRate).color,
                                title: _ctx.getStatus(item.clientStatusCustomRate).label
                              }, null, 8, ["label", "title"]),
                              _createVNode(_component_Icons, {
                                name: 
                      _ctx.isOpen(Number(index)) ? 'chevron-up' : 'chevron-down'
                    ,
                                class: "w-6 text-red-lp-2400 transition-transform"
                              }, null, 8, ["name"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_13, [
                            _createVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(item.updatedAt, "DD MMM YYYY, HH:mm")), 1),
                            _hoisted_15,
                            _createVNode("span", _hoisted_16, _toDisplayString(item.updatedByName), 1)
                          ])
                        ], 2)
                      ]),
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_17, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.history, (history, historyIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              key: historyIndex,
                              class: ["flex flex-col gap-y-1 w-full py-3", historyIndex && 'border-t border-gray-lp-400']
                            }, [
                              _createVNode("div", _hoisted_18, [
                                _createVNode(_component_Icons, {
                                  name: "clipboard",
                                  class: "w-5 text-black-lp-300"
                                }),
                                _withDirectives(_createVNode("span", null, null, 512), [
                                  [_directive_sanitize_html, _ctx.$t(
                    _ctx.STATUS_CLIENT_RATE_HISTORY[
                      history.clientStatusCustomRate as keyof typeof _ctx.STATUS_CLIENT_RATE_HISTORY
                    ].label
                  ).toString()]
                                ])
                              ]),
                              _createVNode("div", _hoisted_19, [
                                _createVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(
                      history.clientStatusUpdatedAt,
                      "DD MMMM YYYY, HH:mm"
                    )), 1),
                                _createVNode("span", _hoisted_21, _toDisplayString(history.clientStatusUpdatedBy), 1)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["activeIndex"])
            ], 4))
          : _createCommentVNode("", true),
      (_ctx.listData.data?.length && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_PaginationV3, {
            key: 2,
            pagination: _ctx.filter.pagination,
            "onUpdate:pagination": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.pagination = $event)),
            onSetPage: _ctx.toPage,
            renderedData: _ctx.listData.data.length,
            paginationWidth: "w-full",
            paginationPaddingVertical: "py-1"
          }, null, 8, ["pagination", "onSetPage", "renderedData"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}